import BaseWebView from './base_web_view';
import {WEB_VIEW_IDS} from './web_view_manager_consts';
import {WEB_VIEW_INFO, WEB_VIEW_REASON} from './web_view_manager_consts';
import {KEY_NAME} from '../../native/native_const';

class SafariWebView extends BaseWebView {

    static CLASS = 'SafariWebView';

    /**
     * isValidId
     * return return true if the id of safari is correct
     */
    isValidId() {
        return WEB_VIEW_IDS.SAFARI_ID === this._id;
    }

    /**
     * onHybridCall - call from hybrid
     * data example: {type: "webviewmanagerfeature", action: "closesafari", webid: 1000}
     */
    onHybridCall(data) {
        let reason = this.getReason(data);
        switch (reason) {
            case WEB_VIEW_REASON.CLOSE_BUT_CLICKED:// close but clicked
                this.onclose();
                break;
            case WEB_VIEW_REASON.CLOSE_BY_WEB: // close call by web
                this.onclose();
                break;
            default:
                // maybe should throw an Exception here
                break;
        }
    }

    /**
     * get Reason to act with the currect action
     * data example: {type: "webviewmanagerfeature", action: "closesafari", webid: 1000}
     */
    getReason(data) {
        let val = data[KEY_NAME.ACTION];
        if (WEB_VIEW_INFO.CLOSE_BUT_CLICKED === val) {
            return WEB_VIEW_REASON.CLOSE_BUT_CLICKED;
        } else if (WEB_VIEW_INFO.CLOSE_CALLED_BY_WEB === val) {
            return WEB_VIEW_REASON.CLOSE_BY_WEB;
        }

        return WEB_VIEW_REASON.UN_DEFINED;
    }

}

export default SafariWebView;